<template>
  <div class="temporary_duty">
    <div class="search">
      <div class="search_box">
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[0].title}}</span>
          <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
            <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[1].title}}</span>
          <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
            <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[2].title}}</span>
          <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
            <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn_box">
          <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getDeviceList(),getResourceList()">
            <span class="el-icon-search"></span>搜索
          </button>
        </div>
        <div class="add_btn_box">
          <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="batchStopPlay(null)" >
            <span class="el-icon-video-pause"></span>批量停止
          </button>
          <button :class='["add_btn","add","icon_btn","clearborder"]' @click="batchStartPlay(null)" >
            <span class="el-icon-video-play"></span>批量开始
          </button>
        </div>
      </div>
    </div>
    <!--table-->
    <div class="table_content" style="margin-right:2%">
      <table>
        <thead>
          <tr>
            <th style="width: 50px !important;">
              <input type="checkbox" name="issue_all" />
            </th>
            <th style="width: 100px !important;">序号</th>
            <th>文件名称</th>
            <th>文件大小</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in resourcePageData" v-bind:key="index">
            <td style="width: 50px !important;">
              <input type="checkbox" name="issue" v-model="selectedResources" :value="item.name"/>
            </td>
            <td style="width: 100px !important;">{{index+1}}</td>
            <td>{{item.name}}</td>
            <td>{{item.time}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table_content">
      <table>
        <thead>
          <tr>
            <th style="width: 50px !important;">
              <input type="checkbox" name="issue_all" />
            </th>
            <th>灯杆编号</th>
            <th>设备ID</th>
            <th>设备名称</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in devicePageData" v-bind:key="index">
            <td style="width: 50px !important;">
              <input type="checkbox" name="issue" v-model="selectedDevices" :value="item.device_id"/>
            </td>
            <td style="width: 100px !important;">{{item.sort}}</td>
            <td>{{item.device_id}}</td>
            <td>{{item.name}}</td>
            <td class="table_btn">
              <button  v-if="item.task==0" @click="startPlay(item.device_id)">开始广播</button>
              <button  v-if="item.task!=0" @click="stopPlay(item.device_id)">停止广播</button>
              <button @click="GetLouder(item.device_id,item.name),controlVoice=!controlVoice" >编辑</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

   <div class="table_paging" style="margin-right:1.6%">
      <p>当前记录<span>{{(this.resourceCurrentPage-1)*9+1}}</span>到<span>{{(this.resourceCurrentPage-1)*9+this.resourcePageData.length}}</span>条，共<span>{{this.resourceTotalCount}}</span>条记录
        <button @click="resourceFirstPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
        <button
          @click="resourcePrevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
        第<span>{{resourceCurrentPage}}</span>/<span>{{Math.ceil(resourceTotalCount/pageSize)}}</span>页
        <button
          @click="resourceNextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
        <button @click="resourceLastPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
      </p>
    </div>
    <div class="table_paging">
      <p>当前记录<span>{{(this.deviceCurrentPage-1)*9+1}}</span>到<span>{{(this.deviceCurrentPage-1)*9+this.devicePageData.length}}</span>条，共<span>{{this.deviceTotalCount}}</span>条记录
        <button @click="deviceFirstPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
        <button
          @click="devicePrevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
        第<span>{{deviceCurrentPage}}</span>/<span>{{Math.ceil(deviceTotalCount/pageSize)}}</span>页
        <button
          @click="deviceNextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
        <button @click="deviceLastPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
      </p>
    </div>

    <!--  编辑-->
    <transition name="fade">
      <div class="mark" v-if="controlVoice">
        <div class="mark_close" @click="controlVoice=!controlVoice"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'800px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              编辑
            </h1>
            <div style="color:white;padding-left: 120px;padding-top: 40px;">
              设备编号：<el-input v-model="Pdevice_id" placeholder="请输入设备编号" style="width: 200px;" :disabled="true"></el-input>
            </div>
            <div style="color:white;padding-left: 120px;padding-top: 40px;">
              设备名称：<el-input v-model="soundName" placeholder="请输入设备名称" style="width: 200px;"></el-input>
            </div>
            <p style="height: 58px;color: white;padding-left: 120px;padding-top: 40px;">
              <span style="float: left;height: 38px;line-height: 38px;margin-right: 10px">音量：</span>
              <el-slider
                :show-tooltip="false"
                v-model="louderData"
                :step="1"
                :min="1"
                :max="15"
                :marks="marks"
                style="width: 70%;float: left">
              </el-slider>
            </p>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="controlVoice=!controlVoice,DeleteLouder()">关闭</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="louderVoice_sbt(louderData),controlVoice=!controlVoice">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: "temporary_duty",
  data() {
    return {
      search: [
        {
          title: '选择项目',
          options: [],
        }, {
          title: '选择群组',
          options: [],
        }, {
          title: '选择小组',
          options: [],
        },
      ],
      selectWorkValue:'',
      selectProjectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
      selectTeamValue:'',
      projectList:[],
      teamList:[],
      workList:[],
      Pdevice_id:'',
      controlVoice:false,
      louderData:0,
      soundName:'',
      JudgeData:'',

      marks: {
        1:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '1')
        },
        2:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '2')
        },
        3:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '3')
        },
        4:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '4')
        },
        5:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '5')
        },
        6:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '6')
        },
        7:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '7')
        },
        8:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '8')
        },
        9:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '9')
        },
        10:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '10')
        },
        11:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '11')
        },
        12:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '12')
        },
        13:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '13')
        },
        14:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '14')
        },
        15:{
          style: {
            color: '#ffffff'
          },
          label: this.$createElement('strong', '15')
        },

      },


   
      projectId: "f899dfb4a9094ac48fbb27b64021d5e1",
      pageSize: 9, // 每页显示数量

      resourceTotalCount: 0,  // 总记录条数
      resourceCurrentPage: 1, // 当前页数 ，默认为1
      resourcePageData: [],   // 当前页数据

      deviceCurrentPage: 1,   //当前页数 ，默认为1
      devicePageData: [],     // 当前页数据
      deviceTotalCount: 0,    // 总记录条数

      selectedResources:[],   //被选中的媒体资源
      selectedDevices:[],   //被选中的媒体资源
    };
  },

  methods: {
    InitLeftMenu: function() {
      this.$emit("getMessage", "5", "3");
    },


    //获取小组列表
    getSelectWork:function(id){
      fetch("/api/v1/controller/list", {
        method: 'post',
        body: JSON.stringify({
          "groups_id":id,
          "page_size":10,
          "page_start":0,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "小组数据获取成功";
            this.search[2].options=[];
            this.workList = data.data;
            let options = this.search[2].options;
            for (let i=0;i<this.workList.length;i++){
              let projectObj = {};
              projectObj.label = this.workList[i].name;
              projectObj.value = this.workList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },



    //获取群组列表
    getSelectTeam:function(id){
      fetch("/api/v1/groups/list", {
        method: 'post',
        body: JSON.stringify({
          "project_id":id,
          "page_size":10,
          "page_start":0,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "群组数据获取成功";
            this.search[1].options=[];
            this.search[2].options=[];
            this.teamList = data.data;
            let options = this.search[1].options;
            for (let i=0;i<this.teamList.length;i++){
              let projectObj = {};
              projectObj.label = this.teamList[i].name;
              projectObj.value = this.teamList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },


    //获取项目列表
    getProjectList:function(){
      fetch("/api/v1/project/list", {
        method: 'post',
        body: JSON.stringify({

        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "项目数据获取成功";
            this.projectList = data.data;
            let options = this.search[0].options;
            for (let i=0;i<this.projectList.length;i++){
              let projectObj = {};
              projectObj.label = this.projectList[i].name;
              projectObj.value = this.projectList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },


    GetLouder:function(Pdevice_id,soundName){
       this.Pdevice_id = Pdevice_id,
         this.soundName = soundName,
         fetch("/api/v1/sounder/device/single", {
           method: 'post',
           body: JSON.stringify({
             "device_id":this.Pdevice_id,
           })
         })
           .then(result => {
             return result.json();//解析流
           })
           .then(data => {
             if (data.code == "200") {
               this.message = "操作成功";
               this.msg_show = !this.msg_show;
               this.louderData=parseInt(data.data.bcoutv);

             } else {
               this.message = "操作异常，请重试";
               this.msg_show = !this.msg_show;
               alert("操作异常，请重试");
             }
           })

    },

    DeleteLouder:function(Pdevice_id){
        this.Pdevice_id = '',
        this.soundName = ''
    },


    //调节音量
    louderVoice_sbt: function (louderData) {
      fetch("/api/v1/sounder/device/volume", {
        method: 'post',
        body: JSON.stringify({
          "device_id":this.Pdevice_id,
          "volume": louderData,
          "name" : this.soundName,

        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          console.log(data)
          if (data.code == "200") {
            this.message = "当前音响编辑成功";
            this.refresh = true;
            this.msg_show = !this.msg_show;
            alert(this.message);
            this.timer = setTimeout(this.getDeviceList, 1000);
          } else {
            this.message = "操作异常，请重试";
            this.brightness = !this.brightness;
            this.msg_show = !this.msg_show;
            alert("操作异常，请重试");
          }
        })
        .catch((error) => {
          this.message = "网络连接异常，请重试";
          this.msg_show = !this.msg_show;
          alert("网络连接异常，请重试");
          throw error;
        });
    },


    batchStartPlay:function(device_id){
      var device_list = "";
      if(device_id == null){
        device_list = this.selectedDevices.join("<");
      }else{
        device_list = device_id;
      }
      fetch("/api/v1/sounder/temporary/play", {
        method: 'post',
        body: JSON.stringify({
          device: device_list,
          filename: this.selectedResources.join("<"),
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.getDeviceList();
            console.log(data.msg);
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    batchStopPlay:function(device_id){
      var device_list = "";
      if(device_id == null){
        device_list = this.selectedDevices;
      }else{
        device_list = [device_id];
      }
      fetch("/api/v1/sounder/temporary/stop", {
        method: 'post',
        body: JSON.stringify({
          device_id: device_list
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.getDeviceList();
            console.log(data.msg);
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    startPlay: function (device_id) {
      this.batchStartPlay(device_id);
      $("#idhe").hide();
    },
    stopPlay: function (device_id) {
      this.batchStopPlay(device_id);
      $("#idhe").show();
    },


    getJudgeList: function () {
      fetch("/api/v1/sounder/temporary/judge", {
        method: 'post',
        body: JSON.stringify({
          project: this.projectId,
        })
      }).then(result => {
        return result.json();//解析流
      }).then(data => {
        if (data.code == "200") {
          this.JudgeData = data.data.play_number;
        }
      }).catch((error) => {
        console.log(error);
      });
    },


    getResourceList: function () {
      fetch("/api/v1/sounder/material/list", {
        method: 'post',
        body: JSON.stringify({
          project: this.selectProjectValue,
          page_start: this.resourceCurrentPage-1,
          page_size: this.pageSize,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.resourceTotalCount = data.total_count;
            this.resourcePageData = data.data;
            // this.timer = setTimeout(this.getDeviceList, 1000);
            this.selectProjectValue='';
            this.selectTeamValue='';
            this.selectWorkValue='';
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    getDeviceList: function () {
      fetch("/api/v1/sounder/plan/device/list", {
        method: 'post',
        body: JSON.stringify({
          project: this.selectProjectValue,
          groups_id:this.selectTeamValue,
          group_id:this.selectWorkValue,
          page_start: this.deviceCurrentPage-1,
          page_size: this.pageSize,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.deviceTotalCount = data.sound_total;
            this.devicePageData = data.sound;
            this.selectProjectValue='';
            this.selectTeamValue='';
            this.selectWorkValue='';
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    //上一页
    resourcePrevPage() {
      if (this.resourceCurrentPage == 1) {
        return false;
      } else {
        this.resourceCurrentPage--;
        this.getResourceList();
      }
    },
    // 下一页
    resourceNextPage() {
      if (this.resourceCurrentPage == Math.ceil(this.resourceTotalCount/this.pageSize)) {
        return false;
      } else {
        this.resourceCurrentPage++;
        this.getResourceList();
      }
    },
    resourceFirstPage(){
        this.resourceCurrentPage = 1;
        this.getResourceList();
    },
    resourceLastPage(){
      this.resourceCurrentPage = Math.ceil(this.resourceTotalCount/this.pageSize);
      this.getResourceList();
    },
     //上一页
    devicePrevPage() {
      if (this.deviceCurrentPage == 1) {
        return false;
      } else {
        this.deviceCurrentPage--;
        this.getDeviceList()
      }
    },
    // 下一页
    deviceNextPage() {
      if (this.deviceCurrentPage == Math.ceil(this.deviceTotalCount/this.pageSize)) {
        return false;
      } else {
        this.deviceCurrentPage++;
        this.getDeviceList()
      }
    },
    deviceFirstPage(){
        this.deviceCurrentPage = 1;
        this.getDeviceList()
    },
    deviceLastPage(){
      this.deviceCurrentPage = Math.ceil(this.deviceTotalCount/this.pageSize);
      this.getDeviceList()
    },
  },
  mounted() {
    this.getJudgeList();
    this.InitLeftMenu();
    this.getResourceList();
    this.getDeviceList();
    this.getProjectList();

  },
  created() {},
  destroyed: function() {}
};
</script>

<style scoped>
.temporary_duty {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  height: 100px;
  padding: 20px 0px 0px;
}

.search_box {
  width: 100%;
  height: 100%;
  margin-right: 10px;
  background: #16518d;
  border-radius: 6px;
  float: left;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}

.search_options_box {
  width: 16%;
  padding: 0 10px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.search_options_box > span {
  width: 64px;
  margin-right: 8px;
  text-align: right;
  color: #ffffff;
}

.search_options_box > select {
  width: calc(100% - 72px);
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  appearance: none;
  padding-left: 10px;
  font-size: 16px;
  outline: none;
  cursor: pointer;
}

.search_options_box option {
  color: #000000;
}

.search_options_box > img {
  position: absolute;
  top: 48px;
  right: 20px;
  cursor: pointer;
}

.search_btn_box {
  width: 80px;
  padding: 10px;
}

.clearborder {
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search_btn {
  width: 100%;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
}

.add_btn {
  width: 110px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  float: right;
  margin-right: 20px;
}

.icon_btn span {
  margin-right: 8px;
}

.green {
  background: #21b868;
  color: #ffffff;
}

.green:active {
  background: #15a95a;
}

.blue {
  background: #7aafeb;
  color: #ffffff;
}

.blue:active {
  background: #4699f7;
}

.yellow {
  background: #f2ae4d;
  color: #ffffff;
}

.yellow:active {
  background: #fa9b15;
}

.add_btn_box {
  /*width: 370px;*/
  padding: 10px;
  position: absolute;
  right: 0px;
}

.add {
  background: #7aafeb;
  color: #ffffff;
  box-shadow: 0 3px 0 #3574ba;
}

.add:active {
  background: #6ca3e2;
}

.publish {
  background: #21b868;
  color: #ffffff;
  box-shadow: 0 3px 0 #188d4f;
}

.publish:active {
  background: #188d4f;
}

.delete {
  background: #f2ae4d;
  color: #ffffff;
  box-shadow: 0px 3px 0px #dc8509;
}

.delete:active {
  background: #e7a342;
}

.table_content {
  float: left;
  width: 49%;
  /* height: calc(100% - 100px);*/
  padding: 20px 0px;
}

.table_content > table {
  width: 100%;
  height: 100%;
  border: 1px solid #094b8e;
  background-color: #16518d;
}

.table_content > table tr th {
  background-color: #0e345b;
}

/* .table_content > table tr td {
  background-color: #16518d;
} */

.table_content > table input {
  width: 16px;
  height: 16px;
}

.table_content > table tr:nth-child(2n) {
  background-color: #11406f;
}

.table_content > table tr {
  /*border-bottom: 1px solid #225892;*/
  height: 62px;
}

.table_content > table tr td,
.table_content > table tr th {
  text-align: center;
  color: #ffffff;
}

.table_content > table tr th select {
  background: transparent;
  color: #ffffff;
  border: none;
  outline: none;
}

.table_content > table tr th select option {
  color: #333333;
}

.table_paging {
  float: left;
  height: 60px;
  width: 49%;
  display: flex;
  align-items: center;
  border: 1px solid #105ba8;
  border-radius: 6px;
}

.table_paging > p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: right;
  margin-bottom: 0;
  color: #c1c2c6;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.table_paging > p > button {
  margin: 0 8px;
  width: 10px;
  height: 16px;
  border: none;
  outline: none;
}

.table_btn > button {
  color: #95bee5;
  background: transparent;
  border: 1px solid #95bee5;
  outline: transparent;
  padding: 5px 20px;
  border-radius: 6px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
.mark {
  position: absolute;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 99999;
  left: 0;
  top: 0;
}

.mark_close {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
}
.model {
  padding: 20px;
  box-sizing: border-box;
}

.model > h1 {
  font-size: 20px;
  color: #00f0ff;
  height: 40px;
  line-height: 40px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #264a7c;
  margin-bottom: 10px;
}

.model > h1 > div {
  float: right;
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
}

.model > h1 > div > label {
  font-size: 16px;
  line-height: 40px;
  color: #ffffff;
  margin-bottom: 0;
}

.model > h1 > div > label > select,
.model > h1 > div > label > input {
  border: 1px solid #ffffff;
  border-radius: 4px;
  background: transparent;
  height: 32px;
  line-height: 32px;
  margin: 0 5px;
  width: 120px;
  color: #ffffff;
  outline: none;
}

.model > h1 > div > label > select > option {
  color: #000000;
}

.model > div {
  width: 100%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
}

.model_input_box {
  width: 100%;
  height: 32px;
  margin: 10px 20px;
  display: flex;
  align-items: center;
}
.input_label {
  width: 70px;
  text-align: right;
  color: #ffffff;
  padding-right: 10px;
}
.input_box > input {
  width: 100%;
  display: inline-block;
  height: 32px;
  font-size: 16px;
  line-height: 32px;
  padding: 0 10px;
  color: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ffffff;
  background: transparent;
  outline: none;
}
.input_box > select {
  width: 150px;
  display: inline-block;
  height: 32px;
  font-size: 16px;
  line-height: 32px;
  padding: 0 10px;
  color: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ffffff;
  background: transparent;
  outline: none;
}
.hint {
  font-size: 12px;
  color: #95bee5;
  padding-left: 10px;
}
.radio_box {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.radio_box > input {
  width: 18px;
  height: 18px;
}
.radio_box > label {
  padding: 0 10px;
  color: #ffffff;
  line-height: 18px;
  margin: 0px;
}
.table_table tr {
  height: 32px;
  border: 1px solid #95bee5;
}
.table_table th,
.table_table td {
  width: 150px;
  color: #ffffff;
  text-align: center;
}
.sbt_box {
  width: 100%;
  height: 80px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/6_loudspeaker/temporary_duty.vue